import { render, staticRenderFns } from "./CompletedFindingsPage.vue?vue&type=template&id=ff24ef4e&scoped=true"
import script from "./CompletedFindingsPage.vue?vue&type=script&lang=js"
export * from "./CompletedFindingsPage.vue?vue&type=script&lang=js"
import style0 from "./CompletedFindingsPage.vue?vue&type=style&index=0&id=ff24ef4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff24ef4e",
  null
  
)

export default component.exports